<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="联系人名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.linkUser" placeholder="请输入用户名称"></el-input>
					</el-form-item> -->
					<el-form-item label="品牌名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.brandName" placeholder="请输入品牌名称"></el-input>
					</el-form-item>
					<el-form-item label="是否推存" class='tiny' cleartable>
						<el-select v-model="searchInfo.isHot" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="推荐" :value="true"></el-option>
							<el-option key="1" label="不推荐" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.checkState" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" value="0">待审核</el-option>
							<el-option key="1" label="通过" value="1">通过</el-option>
							<el-option key="2" label="驳回" value="2">驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="品牌状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="过期" :value="0"></el-option>
							<el-option key="1" label="正常" :value="1"></el-option>
							<el-option key="2" label="停用" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="adduser"> 新增品牌 </el-button>
							
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="联系人">
							<span>{{props.row.linkUser?props.row.linkUser:'无'}}</span>
						</el-form-item>
						<el-form-item label="联系方式">
							<span>{{props.row.phone?props.row.phone:'无'}}</span>
						</el-form-item>
						<el-form-item label="邮箱">
							<span>{{props.row.email?props.row.email:'无'}}</span>
						</el-form-item>
						<el-form-item label="地址">
							<span v-if="props.row.province">{{ props.row.province }} {{props.row.city}} {{props.row.area}}
								{{props.row.address}}</span>
							<span v-else>无</span>
						</el-form-item>
						<el-form-item label="品牌照片">
							<el-button size="small" type="text" @click="introduces(props.row.brandPromotionalImages)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="简介">
							<el-button size="small" type="text" @click="introduce(props.row.brandIntro)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="入驻说明">
							<el-button size="small" type="text" @click="introduce(props.row.storeApplyMemo)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="入驻城市">
							<span>{{ props.row.storeApplyCity==0?'不限制':props.row.cityName }}</span>
							
						</el-form-item>
						<el-form-item label="经营类目">
							<span>{{ props.row.storeApplyClassify }}</span>
							
						</el-form-item>
						<el-form-item v-if="props.row.checkState==2" label="驳回原因">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>
						<el-form-item v-if="props.row.status==0" label="禁用说明">
							<span>{{ props.row.refuseReason }}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="brandName" label="品牌名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="brandLogo" label="店铺LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.brandLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="brandTrademark" label="商标" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.brandTrademark" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			<el-table-column prop="isHot" label="是否推荐" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isHot">推荐</p>
					<p v-else>不推荐</p>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="linkUser" label="联系人" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="电话" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="address" label="地址" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="checkState" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.checkState==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
					<p v-if="scope.row.checkState==1" style="color:#67C23A;font-weight: bold;">通过</p>
					<p v-if="scope.row.checkState==2" style="color:#F56C6C;font-weight: bold;">驳回</p>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="品牌状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">过期</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</p>
					<p v-if="scope.row.status==2" style="color:#F56C6C;font-weight: bold;">停用</p>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="注册时间"  align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column label="操作" align="center">
			　　　<template slot-scope="scope">
				　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
					编辑</el-button>

					<el-button size="small" type="text" @click="viewStore(scope.row)">
						连锁门店</el-button>
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="editialogVisible(scope.row.id)"
								v-if="scope.row.checkState==0">审核</el-dropdown-item>

							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==2">启用</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==1">停用</el-dropdown-item>

							<el-dropdown-item @click.native="toDelete(scope.row.id)" style="color:red;">删除</el-dropdown-item>

						</el-dropdown-menu>
					</el-dropdown>
				</template>
				
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		
		<!-- 新增、编辑 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName+'品牌'" :closeOnClickModal="false"
			:visible.sync="dialogVisibleuser" width="1200px">
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium" label-width="140px">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item  label="选择用户" v-if="dialogVisibleFunName == '新增'" style="width: 400px;">
							<el-select filterable v-model="storeInfo.userId" class="big" placeholder="请输入用户名称后选择用户" clear 
								:remote-method="getUserList"
								:loading="storeLoading"
								remote
								reserve-keyword
								style="width:100%">
								<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.username">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="用户" v-else style="width: 400px;">
							<el-input type="text" v-model="storeInfo.userName" placeholder="请输入" disabled />
						</el-form-item>
						
					</div>
					<div style="display: flex;padding: 20px 80px;">
						加盟费
					</div>
					<div style="display: flex;align-items: center;">
						
						<el-form-item  label="一季度(市场价/现价)" style="width: 400px;">
							<el-input type="number" v-model="franchiseFeesOld1" placeholder="设置原价" />
							<el-input type="number" v-model="franchiseFees1" placeholder="设置现价" />
						</el-form-item>
						<el-form-item  label="半年(市场价/现价)" style="width: 400px;">
							<el-input type="number" v-model="franchiseFeesOld2" placeholder="设置原价" />
							<el-input type="number" v-model="franchiseFees2" placeholder="设置现价" />
						</el-form-item>
						<el-form-item label="一年(市场价/现价)"  style="width: 400px;">
							<el-input type="number" v-model="franchiseFeesOld3" placeholder="设置原价" />
							<el-input type="number" v-model="franchiseFees3" placeholder="设置现价" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item  label="品牌名称" style="width: 400px;">
							<el-input type="text" v-model="storeInfo.brandName" placeholder="请输入品牌名称" />
						</el-form-item>
						<el-form-item  label="排序" style="width: 400px;">
							<el-input type="number" v-model="storeInfo.orderIndex" placeholder="请输入排序" style="width: 150px;"/>
							越大越靠前
						</el-form-item>
						<el-form-item label="是否推荐"  style="display: flex;align-items: center;width: 400px;">
							<el-switch v-model="storeInfo_isHot" >
							</el-switch>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						
						<el-form-item  label="经营类目" style="width: 400px;">
							<el-select filterable v-model="storeInfo.storeApplyClassify" placeholder="请选择经营类目"
							multiple style="width:300px;"
							>
								<el-option v-for="item in BusinessCategoryList" :key="item.id" :value="item.id+''" 
								:label="item.className">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="是否限制开放城市"  style="display: flex;align-items: center;width: 400px;">
							<el-switch v-model="isXz" >
							</el-switch>
						</el-form-item>
						<el-form-item v-if="isXz"  label="开放城市" style="width: 400px;">
							<el-select filterable v-model="storeInfo.storeApplyCity" placeholder="请选择开放城市"
							multiple style="width:300px;"
							>
								<el-option v-for="item in ctList" :key="item.id" :value="item.id+''" :label="item.name">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					</div>
					<div style="display: flex;align-items: center; justify-content: space-between;">
						<el-form-item label="LOGO" style="width: 400px;">
							<el-upload style="width:auto;height:auto;" :class="{hide: brand_logo.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="brand_logo" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemove2"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess2" >
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="商标"  style="width: 400px;">
							<el-upload :class="{hide: brand_trademark.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="brand_trademark" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemove3"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess3" >
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;width: 100%;">
						<el-form-item label="品牌图片" style="width: 1000px;">
							<el-upload style="width:auto;height:auto;"  :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="brandPromotionalImages" :show-file-list="true"  list-type="picture-card" :on-remove="handleRemove4"
								 :on-success="onSuccess4" accept=".jpg, .jpeg, .png, .bmp, .BMP, .JPG, .PNG, .JPEG">
								<i class="el-icon-plus avatar-uploader-icon"></i>
								<!-- :before-upload="beforeAvatarUpload" -->
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;">
						<el-form-item label="品牌简介" style="width: 1050px;">
							<el-input :rows="7" type="textarea" maxlength="200" show-word-limit v-model="storeInfo.brandIntro"
								placeholder="请输入品牌简介" />
						</el-form-item>
					</div>
					<el-form-item label="入驻说明" style="width: 1050px;">
						<div id="lpc-quill" class="quill" style="height: 300px;">
							<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
								:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="storeInfo.storeApplyMemo" ref="myQuillEditor" class="editer" :options="editorOption"
								@ready="onEditorReady($event)" style="height: 200px;">
							</quill-editor>
						</div>
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="联系人" style="width: 400px;">
							<el-input type="text" v-model="storeInfo.linkUser" placeholder="请输入联系人" />
						</el-form-item>

						<el-form-item label="手机号" style="width: 400px;">
							<el-input type="text" v-model="storeInfo.phone" placeholder="请输入手机号" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="邮箱"  style="width: 400px;">
							<el-input type="text" v-model="storeInfo.email" placeholder="请输入邮箱" />
						</el-form-item>
					</div>
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="所属区域:" >
                            <el-select clearable filterable v-model="storeInfo.provinceId" placeholder="请选择省"
                                @change="provinceFocus">
                                <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="storeInfo.cityId" placeholder="请选择市"
                                @change="cityFcus">
                                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select clearable filterable v-model="storeInfo.regionId" placeholder="请选择区"
                                @change="districtFcus">
                                <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
					</div>
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="详细地址"  style="width: 800px;">
							<el-input type="text" v-model="storeInfo.address" placeholder="请输入详细地址" />
							<!-- <el-button icon="el-icon-position" @click="openMap()" type="primary"></el-button> -->
						</el-form-item>
                    </div>
					<div>
						<!-- <el-select v-model="value1" multiple placeholder="请选择">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select> -->
					</div>
					
		
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisibleuser = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false"
        title="详情">
            <div v-if="popupType == 1">
                <el-carousel indicator-position="outside" style="height: 600px;">
                    <el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
                        <img :src="item" style="width: 100%; height: 100%;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-if="popupType==2">
                <div v-html="dialogHtml"></div>
            </div>
            <div style="height:30px"></div>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>

		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px">
			<div style="text-align: center;">
				<img width="600px" style="width:600px;height:auto" :src="popupImageUrl">
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 审核 -->
		<el-dialog :visible.sync="dialogshenheVisible" title="审核" :close-on-click-modal="false">
			<div style="display: flex;">
				<el-form :model="auditInfo" style="margin-left: 10px;">
					<el-form-item label="用户：">{{auditInfo.userName}}</el-form-item>
					<el-form-item label="品牌名称：">{{auditInfo.brandName}}</el-form-item>
					<el-form-item label="排序：">{{auditInfo.orderIndex}}</el-form-item>
					<el-form-item label="是否推荐：">
						<!-- {{auditInfo.isHot}} -->
						<span v-if="auditInfo.isHot">推荐</span>
						<span v-else>不推荐</span>
					</el-form-item>
					<el-form-item label="LOGO：">
						<el-button v-if="auditInfo.brandLogo" size="small" type="text" 
							@click="clickImg(auditInfo.brandLogo)">
							查看</el-button>
						<span v-else>暂无</span>
					</el-form-item>
					<el-form-item label="商标：">
						<el-button v-if="auditInfo.brandTrademark" size="small" type="text" 
							@click="clickImg(auditInfo.brandTrademark)">
							查看</el-button>
						<span v-else>暂无</span>
					</el-form-item>
					<el-form-item label="品牌简介：">{{auditInfo.brandIntro}}</el-form-item>
					<el-form-item label="联系人：">{{auditInfo.linkUser}}</el-form-item>
					<el-form-item label="手机号：">{{auditInfo.phone}}</el-form-item>
					<el-form-item label="邮箱：">{{auditInfo.email}}</el-form-item>
					<el-form-item label="地址：">
						{{auditInfo.province}}+{{auditInfo.city}}+{{auditInfo.area}}+{{auditInfo.address}}
					</el-form-item>
				</el-form>
				
			</div>
			<div slot="footer" class="dialog-footer" style="">
				<el-button @click="delcheckStore()">驳 回</el-button>
				<el-button type="primary" @click="auditPass()" :loading="shtgLoading">通 过</el-button>
			</div>
			
		</el-dialog>


		<!-- 审核驳回 -->
		<el-dialog style="float:rigin" title="审核驳回" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" size="medium">
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="refuseReason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button :loading="editStoreInfoCheckLoading" type="primary" @click="editStoreInfoCheck()">提交
						</el-button>
						<el-button @click="editDialogVisible=false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<MapSelect ref="ms" @on-select="selectAddress" />	

		<!-- 查看认领店铺 -->
		<el-dialog center title="查看连锁门店" :visible.sync="inviteDialogVisible" width="90%" :close-on-click-modal="false">
			<div style="padding:0 30px">
				<!-- <div>品牌信息</div> -->
				<el-form class="demo-form-inline">
					<div style="display: flex;align-items: center;">
						<el-form-item label="品牌名称：" style="width:400px">
							<span>{{ brandInfo.brandName }}</span>
						</el-form-item>
						<el-form-item label="联系人/电话：" style="width:400px">
							<span>{{ brandInfo.linkUser }}/{{ brandInfo.phone }}</span>
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;">
						
						<el-form-item label="地址：" style="width: 400px;;">
							<span>{{ brandInfo.province }}{{ brandInfo.city }}{{ brandInfo.area }}{{ brandInfo.address }}</span>
						</el-form-item>
						<el-form-item label="品牌简介：" >
							<span>{{ brandInfo.brandIntro }}</span>
						</el-form-item>
					</div>
					
				</el-form>
			</div>
			<el-table :data="claimStoreData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="claimStoreDataLoading" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading">
				
				<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="storeLogo" label="店铺LOGO" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
					</template>
				</el-table-column>
					<el-table-column prop="linkUser" label="联系人" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{scope.row.linkUser}}-{{scope.row.phone}}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="phone" label="电话" align="center" :show-overflow-tooltip="true">
				</el-table-column> -->
				<el-table-column prop="address" label="地址" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="businessHours" label="经营时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="applyMemo" label="加盟备注" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-button v-if="scope.row.applyMemo" @click="lookText(scope.row.applyMemo)">查看</el-button>
						<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column  label="加盟时长" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						
						<span v-if="scope.row.joinTime">{{ leaveTime(scope.row.joinTime) }} ~ {{ leaveTime(scope.row.endTime) }}</span>
						<span v-else>暂无</span>
					</template>
				</el-table-column>
				<el-table-column label="加盟费" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span v-if="scope.row.franchiseFee==0">免费</span>
						<span v-else>￥ {{scope.row.franchiseFee}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.authStatus==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
						<p v-if="scope.row.authStatus==1" style="color:#67C23A;font-weight: bold;">通过</p>
						<p v-if="scope.row.authStatus==2" style="color:#F56C6C;font-weight: bold;">驳回</p>
						<p v-if="scope.row.authStatus==3" style="color:#35333c;font-weight: bold;">加盟到期待续约</p>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.status==0">停用</p>
						<p v-if="scope.row.status==1">正常</p>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="入驻时间"  align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="操作" align="center">
			　　　　<template slot-scope="scope">
						<el-button size="small" type="text" @click="delstore(scope.row.id)">解除关系</el-button>　　
			　　　　</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background :current-page="claimStoreData.pageNum"
				@current-change="pageInviteChange" :page-sizes="[10, 20, 50, 100, 150, 200]" layout="total, sizes, prev, pager,next"
				:total="claimStoreData.total" @size-change="handleInviteSizeChange">
			</el-pagination>
			<div style="text-align: center;">
				<el-button @click="inviteDialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogText" :closeOnClickModal="false" width="700px" title="加盟备注">
			<div style="text-align: center;">
				{{ popupDialogTextl }}
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogText = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
    var urls = uploadFileServer('pp');
    
    import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	import MapSelect from '@/components/MapSelect'
	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor,
			MapSelect
		},  
		data() {
			return {
				isXz:false,
				BusinessCategoryList:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									font: [],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				httpUrl: urls ,
				loading: false,
				dialogVisibleImg:false,
				dialogImageUrl:[],

				storeList: [{}], //
				propertyDialogVisible: false,
				
				dialogVisible: false,
				
				dialogVisibleFunName:'',

				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10
				},
                searchInfo: {
					isHot: '',
					checkState: '',
					status: '',
				},
                
				//新增弹窗
				dialogVisibleuser:false,
				ctList:[],
				franchiseFeesOld1:'',
				franchiseFees1:'',
				franchiseFeesOld2:'',
				franchiseFees2:'',
				franchiseFeesOld3:'',
				franchiseFees3:'',
				storeInfo:{
				
				},
				brand_logo : [], //logo,
				brand_trademark: [] , //商标,
				brandPromotionalImages:[],
				storeInfo_isHot: true,
				
                popupType: 1, //弹窗类型
                dialogHtml:"",

                getProductList: [],
                froductListShow: [],

                provinceList: {},
				cityList: {},
                districtList: {},
                
                addLoading: false,
				sureLoading: false,
				
				timerArr:[],
				timerArrTwo: [],

				mainForm:{},
				// address:'',
				latitude:'',
				longitude:'',
				storeInfoStatus: 1,

				dialogImg:false,
				popupImageUrl: '',

				dialogshenheVisible: false,
				editDialogVisible: false,
				editStoreInfoCheckLoading: false,
				shtgLoading: false,
				companyID: '',
				refuseReason: '',
				auditInfo: {},
	

				succeedPop: false,
				succeedPopText: '',

				validityType: 1,

				accountList: [],
				storeLoading: false,

				//品牌下的店铺
				brandInfo: {},
				claimStoreID: '',
				claimStoreData: {},
				claimStoreDataLoading: false,
				inviteDialogVisible: false,

				dialogText: false,
				popupDialogTextl: ''
			};
		},
		watch: {
			isXz(newValue, oldValue) {
				if(oldValue==false){
					this.storeInfo.storeApplyCity.splice(0,1)
				}
				
			}
		},
		methods: {
			lookText(e){ //加盟备注弹窗
				this.popupDialogTextl = e;
				this.dialogText = true;
			},
			leaveTime(value){ //格式化时间  年-月日
				return this.$moment(value).format('YYYY-MM-DD');
			},
			delstore(id){
				var str = "确认解除该店铺与品牌关系, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.deleteByIdRelationship(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.page.pageNum = 1;
							this.showClaimStore();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						username: e,
						pageNum: 1,
						pageSize: 20,
					}
					this.$api.getUserNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}
			},
			viewStore(row){ //查看品牌下的店铺
				this.brandInfo = row;
				this.claimStoreID = row.id;
				this.page.invitePageNum = 1;
				this.page.invitePageSize = 10;
				this.claimStoreData = {};
			
				this.inviteDialogVisible = true;
					this.showClaimStore()
			},
			pageInviteChange(val) {
				this.page.invitePageNum = val
				this.showClaimStore()
			},
			handleInviteSizeChange(val) {
				this.page.invitePageSize = val
				this.showClaimStore()
			},
			showClaimStore(){ //查看品牌下的全部店铺
				this.claimStoreDataLoading = true;
				let data = {
					chainId: this.claimStoreID,
					pageNum: this.page.invitePageNum,
					pageSize: this.page.invitePageSize,
				}
				this.$api.ChainStoreRelationship(data).then((res) => { 
				// this.$api.getClaimStoreClaimStore(data).then((res) => { 
					if (res.state == 'success') {
						// console.log('邀请下级---', res.data.list[0])
						this.claimStoreData = res.data;
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
					this.claimStoreDataLoading = false
				})
			},

			editialogVisible(id) { //审核弹窗打开
				this.auditInfo = {};
				this.companyID = id;
				this.$api.getChainStoreInfoByID(id).then(res=>{
					if(res.state == 'success'){
						this.auditInfo = res.data;
					}else{
						this.$message.error(res.message);
					}
				})
				this.dialogshenheVisible = true;
			},
			auditPass(){ //审核通过
				this.shtgLoading = true;
				let data={
					id: this.companyID,
					checkState: 1
				}
				this.$api.auditChainStoreInfo(data).then(res=>{
					if(res.state == 'success'){
						this.$message.success(res.message);
						this.dialogshenheVisible = false;
						this.getstoreList();
					}else{
						this.$message.error(res.message);
					}
					this.shtgLoading = false;
				})
			},
			delcheckStore(){ // 审核驳回弹窗
				this.refuseReason = "";
				this.editDialogVisible = true;
			},
			editStoreInfoCheck(){ // 审核驳回
				if(this.refuseReason == ""){
					this.$message.error('驳回原因不能为空!');
					return
				}
				this.editStoreInfoCheckLoading = true;
				let data={
					id: this.companyID,
					checkState: 2,
					reason: this.refuseReason
				}
				this.$api.auditChainStoreInfo(data).then(res=>{
					if(res.state == 'success'){
						this.$message.success(res.message);
						this.editDialogVisible = false;
						this.dialogshenheVisible = false;
						this.getstoreList();
					}else{
						this.$message.error(res.message);
					}
					this.editStoreInfoCheckLoading = false;
				})
			},

			storeGoodsHitTheShelfOrSoldOut(id) { //停用启用
				this.$api.ChainStoreHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getstoreList();
					} else {
						this.$message.error(res.message);
					}
				})
			},


			// 打开地图弹窗
			openMap() {
				// console.log(1223)
				this.$refs.ms.show();
				// 根据省市区设置初始值
				this.$refs.ms.setLocationByAddress(this.mainForm.address);
				// 根据经纬度设置初始值
				if(this.storeInfo.lat){
					this.$refs.ms.setLocationByLatLng(this.storeInfo.latitude,this.storeInfo.longitude);
				}else{
					// console.log(this.mainForm.lat,this.mainForm.lng);
				this.$refs.ms.setLocationByLatLng(this.mainForm.lat, this.mainForm.lng);
				}
				
			},
			
			// 地址选择后的回调函数
			selectAddress(address, lat, lng) {
				// console.log('详细地址--',address);
				this.storeInfo.address = address;
				this.latitude=lat
				this.longitude=lng
				
			},
            upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
            },
            uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
            getSheng(){
                //查询省
                this.$api.getAreasFive(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
            },
            //查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的storeList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.province = obj.name
				this.storeInfo.provinceId = e
				this.storeInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				this.storeInfo.cityId = e
				let obj = {};
				obj = this.cityList.find((item) => { //这里的storeList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
			
            },
            districtFcus(e) {
				this.storeInfo.regionId = e
				let obj = {};
				obj = this.districtList.find((item) => { //这里的storeList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeInfo.area = obj.name
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
            introduce(e) { //富文本查看
                this.popupType = 2;
                this.dialogHtml = e;
				this.dialogVisibleImg = true;
			},
			introduces(e) { //富文本查看
			    this.popupType = 1;
			    this.dialogImageUrl = e.split(',');
				this.dialogVisibleImg = true;
			},
            sure() { //编辑
				this.sureLoading = true
				// console.log('123434--', this.brand_logo)
				let data = {
					userId: this.storeInfo.userId,
					brandName: this.storeInfo.brandName,
					brandIntro: this.storeInfo.brandIntro,
					linkUser: this.storeInfo.linkUser,
					storeApplyMemo:this.storeInfo.storeApplyMemo,
					province: this.storeInfo.province,
					city: this.storeInfo.city,
					area: this.storeInfo.area,
					franchiseFees:this.franchiseFees1+','+this.franchiseFees2+','+this.franchiseFees3,
					franchiseFeesOld:this.franchiseFeesOld1+','+this.franchiseFeesOld2+','+this.franchiseFeesOld3,
					provinceId: this.storeInfo.provinceId,
					cityId: this.storeInfo.cityId,
					regionId: this.storeInfo.regionId,

					address: this.storeInfo.address,
					isHot: this.storeInfo_isHot,
					phone: this.storeInfo.phone,
					email: this.storeInfo.email,
					orderIndex: this.storeInfo.orderIndex,
					storeApplyClassify: this.storeInfo.storeApplyClassify.join(','),
					storeApplyCity:this.isXz? this.storeInfo.storeApplyCity.join(','):0,
					
					brandLogo: '',
					brandPromotionalImages:'',
					brandTrademark: '',
					id: this.storeInfo.id
				}
				if(this.brand_logo.length == 1){
					data.brandLogo = this.brand_logo[0].url
				}
				if(this.brand_trademark.length == 1){
					data.brandTrademark = this.brand_trademark[0].url
				}
				let daimg=[]
				this.brandPromotionalImages.forEach(item=>{
					console.log(item);
					daimg.push(item.url)
				})
				
				data.brandPromotionalImages=daimg.join(',')
				this.$api.updateChainStoreInfo(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getstoreList();
						this.dialogVisibleuser = false;
					} else {
						this.$message.error(res.message);
                    }
					this.sureLoading = false
				})
			},
			add(){ //添加
				this.addLoading = true;
				let data={
					userId: this.storeInfo.userId,
					brandName: this.storeInfo.brandName,
					brandIntro: this.storeInfo.brandIntro,
					linkUser: this.storeInfo.linkUser,
					storeApplyMemo:this.storeInfo.storeApplyMemo,
					province: this.storeInfo.province,
					city: this.storeInfo.city,
					area: this.storeInfo.area,
					franchiseFees:this.franchiseFees1+','+this.franchiseFees2+','+this.franchiseFees3,
					franchiseFeesOld:this.franchiseFeesOld1+','+this.franchiseFeesOld2+','+this.franchiseFeesOld3,
					provinceId: this.storeInfo.provinceId,
					cityId: this.storeInfo.cityId,
					regionId: this.storeInfo.regionId,

					address: this.storeInfo.address,
					isHot: this.storeInfo_isHot,
					phone: this.storeInfo.phone,
					email: this.storeInfo.email,
					orderIndex: this.storeInfo.orderIndex,
					storeApplyClassify: this.storeInfo.storeApplyClassify.join(','),
					storeApplyCity:this.isXz? this.storeInfo.storeApplyCity.join(','):0,
					
					brandLogo: '',
					brandTrademark: '',
					brandPromotionalImages:''
				}
				if(this.brand_logo.length == 1){
					data.brandLogo = this.brand_logo[0].url
				}
				if(this.brand_trademark.length == 1){
					data.brandTrademark = this.brand_trademark[0].url
				}
				let daimg=[]
				this.brandPromotionalImages.forEach(item=>{
				
					daimg.push(item.url)
				})
				// console.log(daimg);
				data.brandPromotionalImages=daimg.join(',')
                // console.log('新增信息---', data)
				this.$api.addChainStoreInfo(data).then(res=>{
                    if(res.state=='success'){
                        this.$message({
                            message: res.message,
                            type: 'success'
						});
						this.dialogVisibleuser = false;
                        this.storeInfo={}
						this.getstoreList();
                    }else{
						this.$message.error(res.message);
					}
                    this.addLoading = false;
				})
			},
			adduser(){ //新增弹窗
				this.validityType = 1;
				this.storeInfo={};

				this.brand_logo = []; //logo,
				this.brand_trademark = [] ; //商标,
				 this.brandPromotionalImages=[]
				this.dialogVisibleFunName='新增';
				
				this.dialogVisibleuser = true;
			},
			// 编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo={};
				this.brand_logo = []; //logo,
				this.brand_trademark = [] ; //商标,
				this.brandPromotionalImages=[]
                this.$api.getChainStoreInfoByID(id).then(res=>{
                    if(res.state == 'success'){
						// console.log('数据---', res.data)
						this.storeInfo = res.data;
						this.franchiseFeesOld1=res.data.franchiseFeesOld.split(',')[0]
						this.franchiseFees1=res.data.franchiseFees.split(',')[0]
						this.franchiseFeesOld2=res.data.franchiseFeesOld.split(',')[1]
						this.franchiseFees2=res.data.franchiseFees.split(',')[1]
						this.franchiseFeesOld3=res.data.franchiseFeesOld.split(',')[2]
						this.franchiseFees3=res.data.franchiseFees.split(',')[2]
						
						this.storeInfo.storeApplyClassify=res.data.storeApplyClassify.split(',')
						this.storeInfo.storeApplyCity=res.data.storeApplyCity.split(',')
						if(this.storeInfo.storeApplyCity==0){
							this.isXz=false
						}else{
							this.isXz=true
						}
						if(res.data.brandLogo){
							this.brand_logo.push({
								url: res.data.brandLogo
							}); //LOGO,
						}else{
							this.brand_logo = []
						}
						if(res.data.brandTrademark){
							this.brand_trademark.push({
								url: res.data.brandTrademark
							}); //商标
						}else{
							this.brand_trademark = []
						}
						if(res.data.brandPromotionalImages){
					
							res.data.brandPromotionalImages.split(',').forEach(item=>{
								this.brandPromotionalImages.push({
									url: item
								}); //
							})
							
						}else{
							this.brandPromotionalImages = []
						}
					
                        if(res.data.cityId){
                            this.$api.getAreasFive(res.data.provinceId).then((res) => {
                                if (res.state == 'success') {
                                    this.cityList = res.data
                                }
                            })
                        }
                        if(res.data.areaId){
                            this.$api.getAreasFive(res.data.cityId).then((res) => {
                                if (res.state == 'success') {
                                    this.districtList = res.data
                                }
                            })
                        }
                    }
                    
				})
				this.dialogVisibleFunName='编辑';
				this.dialogVisibleuser=true;
			
			},
			//导出
			downloadFile() {
				let data = {
					...this.searchInfo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					cutTime: this.timerArr ? this.timerArr[1] : "",
				};
				// console.log(data);
				this.$api.exportExcelFactory(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "客户管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			empty() {
				this.timerArr = [];
				this.searchInfo = {};
			},
			search() {
				this.page.pageNum = 1;
				this.getstoreList()
			},

			onSuccess2(response, file, fileList) { //logo
				// console.log(res)
				this.brand_logo.push({
					url: response.message
				});
				// console.log(123, this.brand_logo)
			},
			handleRemove2(file, fileList) {
				this.brand_logo = [];
			},
			onSuccess3(response, file, fileList) { //商标
				// console.log(res)
				this.brand_trademark.push({
					url: response.message
				});
			},
			handleRemove3(file, fileList) {
				this.brandPromotionalImages = [];
			},
			onSuccess4(response, file, fileList) { //商标
				// console.log(res)
				this.brandPromotionalImages.push({
					url: response.message
				});
			
			},
			handleRemove4(file, fileList) {
				// this.brandPromotionalImages = [];
				const indexs = this.brandPromotionalImages.map((item, index) => index).filter(index => this.brandPromotionalImages[index].url === file.url);
				for (let index of indexs) {
					this.brandPromotionalImages.splice(index, 1);
				}
			},
			handlePictureCardPreview(file) {
				// console.log('图片---', file)
				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					// return false;
					return Promise.reject(false);
				};
				// return isLt2M, imgStr;
			},
	
			//删除
			toDelete(id) {
				var str = "确认删除该品牌, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delChainStoreInfoByID(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.page.pageNum = 1;
							this.getstoreList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getstoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getstoreList()
			},
			getstoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}

				this.$api.ChainStoreList(data).then((res) => { //管理列表
					// console.log('店铺管理列表:', res.data.list[0]);
					if (res.state == 'success') {
						this.storeList = res.data
						this.loading = false
					}
				})
			},

		},
		created() {
			this.getstoreList();
            this.$api.BusinessCategoryList({pageNum:1,pageSize:100}).then(res=>{
				this.BusinessCategoryList=res.data.list
			})
			this.$api.findByLevel(2).then(res=>{
				this.ctList=res.data
			})
			
			this.getSheng();
			
			
		}
	};
</script>

<style >
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.hide .el-upload--picture-card {
		display: none;
	}
</style>
